import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/p100/srv/www/netonlinemedia.com/public/netonlinemedia/app/components/WhyChooseUs.tsx");
;
import(/* webpackMode: "eager" */ "/srv/p100/srv/www/netonlinemedia.com/public/netonlinemedia/node_modules/next/dist/client/link.js");
